import IMask from 'imask'

document.addEventListener('DOMContentLoaded', () => {
  const maskOptions = {
    mask: '+{7} (000) 000 - 00 - 00',
  }

  document.querySelectorAll('.form-field__tel').forEach((telInput) => {
    const phoneMask = IMask(telInput, maskOptions)

    const validatePhone = () => {
      telInput.setCustomValidity(
        phoneMask.masked.isComplete ? '' : 'Введите полный номер телефона',
      )
    }

    phoneMask.on('accept', validatePhone)
    phoneMask.on('complete', validatePhone)
    telInput.phoneMask = phoneMask
    validatePhone()
  })
})
